import { useState } from 'react';
import TransactionRow from './TransactionRow.jsx';
import LoadingSpinner from './LoadingSpinner.jsx';
import Button from './Button.jsx';
import TransactionDetailSlideOver from './TransactionDetailSlideOver.jsx';

export default function TransactionList({
  transactions = [],
  isLoading,
  pagination,
  onPageChange,
  categories = [],
  onCategoryChange,
  emptyMessage = 'Aucune transaction',
}) {
  // On garde l'id en state et on re-derive l'objet tx à chaque render :
  // garantit que le SlideOver reçoit les dernières data après refetch
  // (changement de catégorie, marquage récurrence, etc.).
  const [selectedId, setSelectedId] = useState(null);
  const selected = selectedId
    ? transactions.find((t) => t.id === selectedId) ?? null
    : null;

  if (isLoading) {
    return (
      <div className="flex justify-center py-12">
        <LoadingSpinner />
      </div>
    );
  }

  if (transactions.length === 0) {
    return (
      <div className="text-center py-12 text-sm text-slate-500">
        {emptyMessage}
      </div>
    );
  }

  const currentPage = pagination?.page ?? 1;
  const totalPages = pagination?.total_pages ?? 1;

  return (
    <div>
      {/* Header de colonnes desktop uniquement */}
      <div className="hidden md:grid grid-cols-[40px_100px_minmax(180px,1.5fr)_minmax(160px,1fr)_140px] gap-4 items-center px-4 py-2 border-b border-slate-200 bg-slate-50 text-[11px] font-semibold text-slate-500 uppercase tracking-wide">
        <div></div>
        <div>Date</div>
        <div>Fournisseur</div>
        <div>Catégorie</div>
        <div className="text-right">Montant</div>
      </div>

      <div className="divide-y divide-slate-100">
        {transactions.map((tx) => (
          <TransactionRow
            key={tx.id}
            transaction={tx}
            categories={categories}
            onClick={(t) => setSelectedId(t.id)}
          />
        ))}
      </div>
      <TransactionDetailSlideOver
        transaction={selected}
        open={!!selected}
        onClose={() => setSelectedId(null)}
      />
      {totalPages > 1 && (
        <div className="flex items-center justify-between px-4 py-3 border-t border-slate-100">
          <Button
            variant="ghost"
            className="text-xs px-3 py-1.5"
            disabled={currentPage <= 1}
            onClick={() => onPageChange?.(currentPage - 1)}
          >
            Précédent
          </Button>
          <span className="text-xs text-slate-500">
            Page {currentPage} / {totalPages}
          </span>
          <Button
            variant="ghost"
            className="text-xs px-3 py-1.5"
            disabled={currentPage >= totalPages}
            onClick={() => onPageChange?.(currentPage + 1)}
          >
            Suivant
          </Button>
        </div>
      )}
    </div>
  );
}
